import { CopilotConversation } from 'models/copilot/copilotConversation';
import { TenantProcessStatus } from 'models/copilot/tenantProcessStateBase';
import { EntityTypes } from 'models/entity';

// Mirror of ProcessStateEntityEvidenceAudit.Stage (isoplanner-api, PLAN-077 Task 4); the values follow Task 4
export enum EntityEvidenceAuditStage {
  Preparing = 0,
  Judging = 1,
  Completed = 2,
}

/**
 * The AI evidence audit of one asset, risk, process, objective or processing activity as a process (PLAN-077), mirror
 * of ProcessStateEntityEvidenceAudit: keyed on the entity per user, the stage, the report of the finished run and the
 * conversation with the lines the server wrote. The shape is spec 6.7's; appliedTaskId and unchangedSince follow the
 * state Task 4 settles.
 */
export class TenantProcessStateEntityEvidenceAudit {
  status: TenantProcessStatus = TenantProcessStatus.NotStarted;

  entityType: EntityTypes = EntityTypes.NotSet;

  entityId: number = 0;

  entityName?: string;

  stage: EntityEvidenceAuditStage = EntityEvidenceAuditStage.Preparing;

  // a run that ignores the stored report of an unchanged entity (Run again)
  force: boolean = false;

  // the assessment task the run was started for, from the start card
  consumerTaskId?: number;

  // the report of the finished run, shown as the final message
  reportMarkdown?: string;

  // the assessment task whose fields the outcomes were applied to
  appliedTaskId?: number;

  // a cache hit: the date of the stored report, which nothing has changed since
  unchangedSince?: Date;

  traceId?: string;

  conversation: CopilotConversation = new CopilotConversation();
}
